<template>
    <div>
        <div class="w-full d-flex justify-content-end">
            <a-button class="mb-2" type="primary" @click="openCreateUserModal()">Gebruiker toevoegen</a-button>
            <a-button class="mx-2" type="primary" @click="getDrivers()"><a-icon type="sync" /></a-button>
        </div>
        <a-table v-if="!driversLoading" :columns="userColumns" :data-source="drivers">
                      <p slot="name" class="mb-0" slot-scope="data">{{data.first_name}} {{ data.last_name }}</p>
                      <a slot="acties" slot-scope="data">
                        <a-dropdown-button @click="openEditUserModal(data)">
                          <a-icon type="setting" />
                          <a-menu slot="overlay">
                            <a-menu-item key="1" @click="openUserPasswordResetModal(data)"> <a-icon type="mail" />Wachtwoord vergeten email verzenden </a-menu-item>
                            <a-menu-item key="2" @click="openDeleteDriverModal(data)"> <a-icon type="delete" />Verwijderen </a-menu-item>
                          </a-menu>
                        </a-dropdown-button>
                  </a>
        </a-table>
        <div v-if="driversLoading"  class="w-100 d-flex justify-content-center align-items-center">
          <a-spin size="large" />
        </div>
        <a-modal
            title="Chauffeur toevoegen"
            :visible="createUserVisible"
            ok-text="Toevoegen"
            cancel-text="Annuleren"
            @ok="submitCreateUser"
            @cancel="cancelCreateUser"
        >
            <p class="input-label">Voornaam</p>
            <a-input class="mb-2" v-model="createUser.first_name" placeholder="Voornaam" />
            <p class="input-label">Achternaam</p>
            <a-input class="mb-2" v-model="createUser.last_name" placeholder="Achternaam" />
            <p class="input-label">Email</p>
            <a-input class="mb-2" v-model="createUser.email" placeholder="Email" />
            <p class="input-label">Telefoonnummer</p>
            <a-input class="mb-2" v-model="createUser.phone_number" placeholder="Telefoonnummer" />
            <p class="input-label">Wachtwoord</p>
            <a-input-password class="mb-2" v-model="createUser.password" placeholder="Wachtwoord" />
        </a-modal>

        <a-modal
          title="Chauffeur wijzigen"
          :visible="editUserVisible"
          ok-text="Aanpassen"
          cancel-text="Annuleren"
          @ok="submitEditUser"
          @cancel="cancelEditUser"
        >
          <p class="input-label">Voornaam</p>
          <a-input class="mb-2" v-model="editUser.first_name" placeholder="Voornaam" />
          <p class="input-label">Achternaam</p>
          <a-input class="mb-2" v-model="editUser.last_name" placeholder="Achternaam" />
          <p class="input-label">Email</p>
          <a-input class="mb-2" v-model="editUser.email" placeholder="Email" />
          <p class="input-label">Telefoonnummer</p>
          <a-input class="mb-2" v-model="editUser.phone_number" placeholder="Telefoonnummer" />
          <a-checkbox v-model="editUser.sendPasswordReset">Stuur wachtwoord reset email</a-checkbox>
        </a-modal>
        <a-modal
          title="Stuur chauffeur een wachtwoord reset email"
          :visible="userPasswordResetVisible"
          ok-text="Versturen"
          cancel-text="Annuleren"
          @ok="sendUserPasswordResetEmail"
          @cancel="cancelUserPasswordReset"
        >
          <div class="d-flex align-items-center">
            <a-icon type="exclamation-circle" two-tone-color="#e74c3c" style="color: #e74c3c;font-size: 32px;"/>
            <p class="mb-0 ml-3">Weet je zeker dat je de chauffeur een wachtwoord vergeten email wilt verzenden?</p>
          </div>
        </a-modal>
        <a-modal
          title="Verwijder chauffeur"
          :visible="deleteDriverVisible"
          ok-text="Versturen"
          cancel-text="Annuleren"
          @ok="deleteDriver"
          @cancel="cancelDeleteDriver"
        >
          <div class="d-flex align-items-center">
            <a-icon type="exclamation-circle" two-tone-color="#e74c3c" style="color: #e74c3c;font-size: 32px;"/>
            <p class="mb-0 ml-3">Weet je zeker dat je de chauffeur wilt verwijderen?</p>
          </div>
        </a-modal>
    </div>
</template>

<script>

const userColumns = [
  {
    title: 'Naam',
    scopedSlots: { customRender: 'name' },
  }, //TODO totaal prijs
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Telefoonnummer',
    dataIndex: 'phone_number',
    key: 'phone_number',
  },
  {
    title: 'Acties',
    scopedSlots: { customRender: 'acties' },
  },
]

export default {

  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data() {
    return {
      userColumns,
      driversLoading: false,
      drivers: [],
        editUserVisible: false,
        editUser: {},
        userPasswordResetVisible: false,
        createUserVisible: false,
        createUser: {
          first_name: '',
          last_name: '',
          email: '',
          phone_number: '',
          password: '',
        },
        deleteDriverVisible: false,
    }
  },
    mounted() {
        this.getDrivers()
    },
  methods: {
    getDrivers() {
        this.driversLoading = true
        this.$axios.get('/drivers', {
            headers: {
            'Authorization': `Bearer ${this.user.user.token}`,
            } }).then(response => {
            this.driversLoading = false
            this.drivers = response.data
        })
    },
    cancelEditUser() {
      this.editUserVisible = false
    },
    openEditUserModal(user) {
      this.editUser = user
      this.editUserVisible = true
    },
    submitEditUser() {
      this.$axios.post(`/driver/update`, {
        user_id: this.editUser.id,
        first_name: this.editUser.first_name,
        last_name: this.editUser.last_name,
        email: this.editUser.email,
        phone_number: this.editUser.phone_number,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.getDrivers();
        this.editUserVisible = false
        if(this.editUser.sendPasswordReset){
          this.sendUserPasswordResetEmail()
        }else{
          this.editUser = {}
        }
      })
    },
    openUserPasswordResetModal(user) {
      this.userPasswordResetVisible = true
      this.editUser = user
    },
    sendUserPasswordResetEmail() {
      this.$axios.post(`/driver/password-reset`, {
        user_id: this.editUser.id,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.userPasswordResetVisible = false
        this.editUser = {}
      })
    },
    cancelUserPasswordReset() {
      this.userPasswordResetVisible = false
      this.editUser = {}
    },
    openCreateUserModal() {
      this.createUserVisible = true
    },
    cancelCreateUser() {
      this.createUserVisible = false
    },
    submitCreateUser() {
      this.$axios.post(`/driver/create`, {
        first_name: this.createUser.first_name,
        last_name: this.createUser.last_name,
        email: this.createUser.email,
        phone_number: this.createUser.phone_number,
        password: this.createUser.password,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.getDrivers();
        this.createUserVisible = false
        this.createUser = {}
      })
    },
    openDeleteDriverModal(user) {
      this.deleteDriverVisible = true
      this.editUser = user
    },
    deleteDriver() {
      this.$axios.post(`/driver/delete`, {
        user_id: this.editUser.id,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.deleteDriverVisible = false
        this.editUser = {}
        this.getDrivers()
      })
    },
    cancelDeleteDriver() {
      this.deleteDriverVisible = false
      this.editUser = {}
    },
  }
}

</script>